var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconreplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9585 2.29175V17.7084H11.6668C12.012 17.7084 12.2918 17.9882 12.2918 18.3334C12.2918 18.6786 12.012 18.9584 11.6668 18.9584H3.8335C3.21217 18.9584 2.7085 18.4547 2.7085 17.8334V2.16675C2.7085 1.54543 3.21218 1.04175 3.8335 1.04175H13.5431C13.8414 1.04175 14.1276 1.16027 14.3386 1.37125L16.9623 3.99503C17.1733 4.20601 17.2918 4.49215 17.2918 4.79052V10.8334C17.2918 11.1786 17.012 11.4584 16.6668 11.4584C16.3217 11.4584 16.0418 11.1786 16.0418 10.8334V4.8423L13.4913 2.29175H3.9585Z",
    fill: "#F3F3F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3335 1.04175C13.6787 1.04175 13.9585 1.32157 13.9585 1.66675V4.37508H16.6668C17.012 4.37508 17.2918 4.6549 17.2918 5.00008C17.2918 5.34526 17.012 5.62508 16.6668 5.62508H13.8335C13.2122 5.62508 12.7085 5.1214 12.7085 4.50008V1.66675C12.7085 1.32157 12.9883 1.04175 13.3335 1.04175Z",
    fill: "#F3F3F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3916 18.7754C15.6356 19.0194 16.0314 19.0194 16.2754 18.7754L18.7754 16.2754C19.0195 16.0313 19.0195 15.6356 18.7754 15.3915L16.2754 12.8915C16.0314 12.6474 15.6356 12.6474 15.3916 12.8915C15.1475 13.1356 15.1475 13.5313 15.3916 13.7754L16.8246 15.2084H13.3335C12.9883 15.2084 12.7085 15.4882 12.7085 15.8334C12.7085 16.1786 12.9883 16.4584 13.3335 16.4584H16.8246L15.3916 17.8915C15.1475 18.1356 15.1475 18.5313 15.3916 18.7754Z",
    fill: "#F3F3F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconreplace);
export default __webpack_public_path__ + "static/media/iconreplace.02fab5ea3aa4bb9950c661215c94a2e3.svg";
export { ForwardRef as ReactComponent };